/* eslint-disable react-hooks/exhaustive-deps */
import {useTranslation} from "react-i18next"
import debounce from "debounce-promise"
import {groupsService} from "services"
import {KlassDropAsyncPaginate, KlassDropdownAsyncProps} from "../Select"
import {formatCodeName} from "helpers"
import {useCallback} from "react"
import {useQueryClient} from "@tanstack/react-query"

type Props = Partial<KlassDropdownAsyncProps>

export function GroupSelect(props: Props) {
    const {t} = useTranslation(["common"])
    const queryClient = useQueryClient()

    const loadOptions = useCallback(
        debounce(async (search, loadedOptions) => {
            const pageSize = 20
            const page = Math.ceil(loadedOptions.length / pageSize) + 1

            const queryKey = ["group", search, page]
            const cachedData = queryClient.getQueryData(queryKey)
            if (cachedData) {
                return cachedData
            }

            const params = {
                range: {
                    page,
                    pageSize
                },
                filter: {
                    search
                }
            }
            const {data: groups, total} = await groupsService.getAll(params)
            const groupOptions = groups.map((group) => ({
                id: group.groupId,
                name: group.name,
                code: group.code
            }))
            const formatted = {
                options: groupOptions,
                hasMore: loadedOptions.length < total
            }

            queryClient.setQueryData(queryKey, formatted)
            return formatted
        }, 500),
        []
    )

    return (
        <KlassDropAsyncPaginate
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={loadOptions}
            getOptionLabel={formatCodeName}
        />
    )
}
